import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";
import { getErrorMessage } from "#/utils/APIUtils.js";

// your axios instance

/**
 * POST /api/gen/koefSorodstva/zivali-na-zivali
 * payload: { species: string, zivaliA: string[], zivaliB: string[] }
 */
export const calculateZivaliNaZivali = async (payload) => {
  const { data } = await api.post(
    "/api/gen/koefSorodstva/zivali-na-zivali",
    payload
  );
  return data;
};

export const calculateKoefSorodstva = createAsyncThunk(
  "genology/calculateKoefSorodstva",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post(
        "/api/gen/koefSorodstva/zivali-na-zivali",
        payload
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to calculate relatedness"
      );
    }
  }
);

export const calculateKoefSorodstvaCsv = createAsyncThunk(
  "genology/calculateKoefSorodstvaCsv",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/api/gen/koefSorodstva/zivali-na-zivali/csv",
        payload,
        {
          responseType: "blob",
          headers: {
            Accept: "text/csv",
          },
        }
      );
      const disposition = response.headers["content-disposition"];
      const filename =
        disposition?.match(/filename="(.+?)"/)?.[1] ?? "generated.csv";
      return {
        fileName: filename,
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [calculateKoefSorodstvaCsv];

const genologySlice = createSlice({
  name: "genology",
  initialState: {
    lastCalculationRequest: null,
    result: null,
    loadingCalculation: false,
    error: null,
  },
  reducers: {
    resetGenologyResult(state) {
      state.result = null;
      state.lastCalculationRequest = null;
      state.error = null;
      state.loadingCalculation = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(calculateKoefSorodstva.pending, (state, action) => {
        state.loadingCalculation = true;
        state.error = null;
        state.lastCalculationRequest = action.meta.arg || null;
      })
      .addCase(calculateKoefSorodstva.fulfilled, (state, action) => {
        state.loadingCalculation = false;
        state.result = action.payload;
      })
      .addCase(calculateKoefSorodstva.rejected, (state, action) => {
        state.loadingCalculation = false;
        state.error =
          action.payload || action.error?.message || "Failed to calculate";
      })
      .addCase(calculateKoefSorodstvaCsv.fulfilled, (state, action) => {
        state.loadingCalculation = false;
        state.result = action.payload;
      });

    handleLoadingAndErrorState(builder, thunks);
  },
});
export const { resetGenologyResult } = genologySlice.actions;
// DONT USE the selectors globally, use reselect or createSelector in componentsđ
// hook useSelect
export const selectGenologyResult = (s) => s.genology?.result;
export const selectGenologyLoading = (s) => s.genology?.loadingCalculation;
export const selectGenologyError = (s) => s.genology?.error;

export default genologySlice.reducer;
